module.exports = __webpack_public_path__ + "img/icon_solution_text01.acb7ffd3.png";